<template>
  <div v-if="visible" class="overlay">
    <img src="@/assets/flecha.png" style="width:200px;margin-left:-25px;" />
    <div class="instr">
      <p>
        Pulsando en este botón verás todas las pólizas y siniestros que tienes
        en MMT
      </p>
      <button class="closeButton pure-button" @click="close()">
        Entendido
      </button>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
let instrVersion = 2;
export default {
  data() {
    return {
      visible: false
    };
  },

  mounted() {
    // Solo se muestra en escritorio
    if (window.innerWidth < 768) return;
    let vers = Cookies.get("instr-vers");
    this.visible = !vers || instrVersion > vers;
  },

  methods: {
    close() {
      this.visible = false;
      Cookies.set("instr-vers", instrVersion, { expires: 365 * 10, path: "/" });
    }
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0rem;
  left: 0;
  display: block;
  z-index: 10000;
}

.closeButton {
  color: white;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 4px;
  border: 3px solid white;
  font-size: 150%;
  font-weight: bold;
  margin-top: 20px;
}

.instr {
  color: white;
  font-size: 150%;
  font-weight: bold;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 1rem;
  width: 300px;
  margin-left: 50px;
  font-family: "Indie Flower", cursive;
}
</style>